import { ApiBookedItem, ApiExtraUnit, ApiHotelRoom, ApiItem, ApiItemType } from '@ibe/api';
import { sanitize } from '@ibe/services';
import React, { JSX } from 'react';
import Dates from '../Dates';
import { Price } from '../../Components/UI/Price/Price';

interface InfoContentItemProps {
  bookedItem: ApiBookedItem;
  unit: ApiItem;
}

const isHotelRoom = (unit: ApiItem): unit is ApiHotelRoom => {
  return !!(unit as ApiHotelRoom).roomrates;
};
const isExtra = (unit: ApiItem): unit is ApiExtraUnit => {
  return !!(unit as ApiExtraUnit).unitRates;
};

const InfoContentItem = (infoContentItemProps: InfoContentItemProps): JSX.Element => {
  const { bookedItem, unit } = infoContentItemProps;

  return (
    <div className="align-items-center justify-content-between w-100">
      <div>
        <div dangerouslySetInnerHTML={{ __html: sanitize(bookedItem.name) }} />
        <Dates item={bookedItem} />
        {unit && (
          <>
            <div
              dangerouslySetInnerHTML={{
                __html: sanitize(unit.name)
              }}
            />
            {isHotelRoom(unit) &&
              unit.roomrates.length > 0 &&
              unit.roomrates.map(rate => (
                <div
                  key={rate.id}
                  dangerouslySetInnerHTML={{ __html: sanitize(rate.mealTypeDescription) }}
                />
              ))}
            {(bookedItem.subItemType === ApiItemType.EXTRA ||
              bookedItem.subItemType === ApiItemType.DINING) &&
              isExtra(unit) &&
              unit.unitRates &&
              unit.unitRates.length > 0 &&
              unit.unitRates.map(rate => (
                <>
                  {rate.startTime && (
                    <div
                      key={rate.id}
                      dangerouslySetInnerHTML={{ __html: sanitize(rate.startTime) }}
                    />
                  )}
                </>
              ))}
          </>
        )}
      </div>
      <div>
        <div className="d-flex align-items-center justify-content-end">
          {bookedItem.price && bookedItem.price.finalPrice > 0 && (
            <Price price={bookedItem.price} />
          )}
        </div>
      </div>
    </div>
  );
};
export default InfoContentItem;
